module.exports = __webpack_public_path__ + "static/media/german_correa_h.f221ae0d.jpg";